import React, { useEffect, useState } from 'react';
import { Modal, Button, Toast, Message, Field, Input } from 'react-frontier';
import { SetLoading } from '../SiteClasses';
import { Rating } from 'semantic-ui-react';
import { EventWorker } from '../SiteClasses';
import API from '../API';
import { bindFormChange } from '../SiteUtil';

interface RateForm{
	rating: number,
	rating_comment: string,
}

interface ModalProps{
	open: boolean,
	onClose: ()=>void,
	onRated?: (updatedWorker: EventWorker)=>void,
	worker: EventWorker,
	date_id: number,
}

var RateWorkerModal = (props: ModalProps)=>{
	var [formData, setFormData] = useState<RateForm>({ rating: 0, rating_comment: ''});
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);

	useEffect(()=>{
		if(props.open && props.worker){
			setFormData({
				rating: props.worker.rating,
				rating_comment: props.worker.rating_comment
			});
		}
	}, [props.open, props.worker]);

	var onSubmit = (setLoading: SetLoading)=>{
		if(formData.rating === 0) return setModalPrompts(["Selecciona una calificación para el trabajador"]);

		setLoading(true);
		API.rateEventWorker(props.date_id, props.worker.worker_id, formData.rating, formData.rating_comment).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success("Trabajador calificado!");

			var updatedWorker: EventWorker = {
				...props.worker,
				rating: formData.rating,
				rating_comment: formData.rating_comment
			};

			props.onRated?.(updatedWorker);
			props.onClose();
		}).catch(err=>{
			setModalPrompts(["Error inesperado al guardar la calificación (LCL-1)"]);
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onFormChange = bindFormChange(formData, setFormData);

	return <>
		<Modal open={props.open} onClose={props.onClose} size="tiny">
			<Modal.Header>Calificar trabajador</Modal.Header>
			<Modal.Content>
				<Field label='Calificación de trabajador'>
					<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '15px 0'}}>
						<Rating icon="star" rating={formData.rating} maxRating={5} onRate={(event, data) => setFormData({...formData, rating: Number(data.rating)})} size="massive" clearable/>
					</div>
				</Field>
				<Input textarea placeholder='Comentarios adicionales...'  label='Comentarios' value={formData.rating_comment} onChange={onFormChange('rating_comment')} />
				<Message list={modalPrompts} type="error" />
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={props.onClose} text='Cancelar' basic/>
				<Button color='black'onClick={onSubmit} text='Guardar'/>
			</Modal.Actions>
		</Modal>
	</>
};

export default RateWorkerModal;